import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { Performance } from './lib/performance'

// Start monitoring web vitals
Performance.monitorWebVitals()

// Start measuring initial load time
Performance.start('app-initial-load')

// Add global error handler for uncaught errors
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Capture and log errors that happen during initial rendering
const renderApp = () => {
  try {
    const rootElement = document.getElementById('root')
    
    if (!rootElement) {
      console.error('Root element not found in DOM');
      throw new Error('Root element not found')
    }
    
    // Remove loading spinner before React renders
    const loadingSpinner = rootElement.querySelector('.loading-spinner')
    if (loadingSpinner) {
      loadingSpinner.remove()
    }
    
    Performance.start('react-initial-render')
    
    createRoot(rootElement).render(
      <StrictMode>
        <App />
      </StrictMode>
    )
    
    // End initial render measurement after a short delay to capture hydration
    setTimeout(() => {
      Performance.end('react-initial-render')
      Performance.end('app-initial-load')
    }, 100)
  } catch (error) {
    console.error('Error rendering application:', error)
    Performance.end('app-initial-load')
    
    // Show a fallback UI with safe error handling
    const errorContainer = document.createElement('div');
    errorContainer.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;font-family:\'Helvetica Neue\',Helvetica,Arial,-apple-system,sans-serif;color:white;background:linear-gradient(135deg, #151e2d, #0f172a);';
    
    const title = document.createElement('h1');
    title.style.cssText = 'font-size:1.5rem;margin-bottom:1rem;';
    title.textContent = 'Something went wrong';
    
    const errorMsg = document.createElement('p');
    errorMsg.style.cssText = 'color:#f87171;margin-bottom:1.5rem;';
    // Safely set text content to prevent XSS
    errorMsg.textContent = error instanceof Error ? error.message : 'Unknown error';
    
    const reloadButton = document.createElement('button');
    reloadButton.style.cssText = 'padding:0.75rem 1.5rem;background:linear-gradient(135deg, #7eef43, #65d835);color:#151e2d;border:none;border-radius:0.5rem;font-weight:500;cursor:pointer;';
    reloadButton.textContent = 'Reload App';
    reloadButton.onclick = () => window.location.reload();
    
    errorContainer.appendChild(title);
    errorContainer.appendChild(errorMsg);
    errorContainer.appendChild(reloadButton);
    
    document.body.innerHTML = '';
    document.body.appendChild(errorContainer);
  }
}

// Start the application
renderApp()

// VitePWA will handle service worker registration automatically
